import React from "react"

import Contact from "../components/Contact"
import HeroSection from "../components/HeroSection"
import SEO from "../components/SEO"
import { graphql } from "gatsby"

const index = ({ data }) => {
  return (
    <React.Fragment>
      <SEO image={data.file.childImageSharp.fixed} />
      <HeroSection />
      <Contact />
    </React.Fragment>
  )
}

export const query = graphql`
  query {
    file(relativePath: { eq: "thumbnail.jpg" }) {
      childImageSharp {
        fixed(height: 180, width: 180, quality: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default index
